import { PerformanceTeamPersonalReview } from 'app/library/performance-personal-review/models/performance-team-personal-review.model';
import { PerformanceProfilePersonalReview } from './performance-profile-personal-review.model';

export class PerformanceProfilePersonalReviewCommand {
    name: string;
    team_review_id: number;

    constructor(query: PerformanceProfilePersonalReview | PerformanceTeamPersonalReview, teamReviewId?: string) {
        if (query instanceof PerformanceProfilePersonalReview) {
            if (query.name) {
                this.name = query.name;
            }
        }
        if (teamReviewId) {
            this.team_review_id = parseInt(teamReviewId);
        }
    }
}
